import { OnlineStatus } from '../../stores/online-status-store/online-status.enum';

export class UserOnlineStatusModel {
	[id: number]: OnlineStatus;
}

export interface UserOnlineStatusArgument {
	uids: number[];
}

export interface TypingStatusArgument {
	uids: number[];
	message: {
		channelId: number;
		typingUserLinkId: number;
		active: boolean;
	};
}
